import getFromCdn from '@anm/helpers/getFromCdn';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const titleOnMobiles = media.desktop`
      font-size: 16px;
      line-height: 22px;      
`;

const descriptionOnMobiles = media.desktop`
      font-size: 14px;
      line-height: 18px;  
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  ${titleOnMobiles};
`;

export const Description = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-top: 4px;
  ${descriptionOnMobiles}
`;

const tabletStyles = media.desktop`
    top: 10px;
    left: 10px;
    padding: 10px 25px 10px 10px;
`;

export const Wrapper = styled.div`
  z-index: 3;
  position: absolute;
  top: 30px;
  left: 30px;
  background: rgba(41, 42, 43, 0.9);
  border-radius: 10px;
  display: flex;
  align-items: center;
  color: #fff;
  font-family: 'Inter';
  padding: 20px 35px 20px 10px;
  border: 1px solid rgba(255, 255, 255, 0.2);

  ${tabletStyles};

  &:before {
    display: block;
    content: '';
    width: 30px;
    height: 30px;
    margin-right: 14px;
    background: url(${getFromCdn('images/icons/radio_signal.svg')}) no-repeat center / cover;
  }
`;
